import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { NAVIGATION_LABELS } from '../../../helpers/constants'
import NavigationLabel from '../../NavigationLabel/NavigationLabel'

const UnifiedInboxLink = ({ withUpsellingRedirect }) => {
  const { t } = useTranslation(['navbar'])

  return (
    <div className="navmgr-item">
      <NavLink
        className={({ isActive }) => (isActive ? 'navmgr-item__link--active' : 'navmgr-item__link')}
        to={`${withUpsellingRedirect ? '/dashboard/upselling/unifiedInbox' : '/dashboard/chat'}`}
        end
      >
        <span>
          {t('navbar:upsellingLinks.unifiedInbox')}
          <NavigationLabel type={NAVIGATION_LABELS.HIDDEN} locked={withUpsellingRedirect} />
        </span>
      </NavLink>
    </div>
  )
}

UnifiedInboxLink.propTypes = {
  withUpsellingRedirect: PropTypes.bool,
}

export default UnifiedInboxLink
